import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/grupolocal",

        async alterPosition({ id, dest }) {
            const url = this.userUrl({
                path: `/${id}/position/${dest}`
            });

            return Vue.http.put(url);
        },

        async create({ nome, parentId } = {}) {
            const url = this.userUrl({ path: `/` });

            const newLocaleGroup = await Vue.http.post(url, {
                nome,
                parentId
            });

            return newLocaleGroup;
        },

        async update(data) {
            const url = this.userUrl({ path: `/${data.id}` });

            const updateLocalGroup = await Vue.http.put(url, data);

            return updateLocalGroup;
        },

        async get({ id }) {
            const url = this.userUrl({ path: `/${id}` });

            return Vue.http.get(url);
        },

        async delete({ id }) {
            const url = this.userUrl({ path: `/${id}` });

            return Vue.http.delete(url);
        }
    },
    base
);
